<template>
  <div>
    <v-card class="exhibit-height">
      <vue-dropzone
        id="dropzone"
        ref="upload"
        class="match-height"
        :options="options"
        @vdropzone-sending="exhibitSurvey"
        @vdropzone-error="onError"
        @vdropzone-success="onSuccess"
      />
    </v-card>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      isDestroy: false,
      options: {
        url: `${process.env.VUE_APP_DRF_API_URL}/exhibits/`,
        // maxFiles: 1,
        dictDefaultMessage: "Please Upload the File Here",
        // Header settings might be different for S3 Bucket
        headers: {
          "Cache-Control": "",
          "X-Requested-With": "",
          "Authorization": `JWT ${localStorage.getItem("TOKEN_STORAGE_KEY")}`
        },
        addRemoveLinks: true
      }
    };
  },
  computed: {
    ...mapState("survey", ["selectedSurveyNumberForExhibits"]),
  },
  beforeDestroy() {
    this.isDestroy = true;
  },
  methods: {
    ...mapActions("exhibits", ["fetchExhibits", "updateExhibits", "deleteExhibit"]),
    exhibitSurvey(file, xhr, formData) {
      formData.append("survey", this.selectedSurveyNumberForExhibits.pk);
    },
    onError(file, msg, xhr) {
      alert(xhr.statusText);
      this.$refs.upload.removeAllFiles();
    },
    onSuccess(file, response) {
      this.updateExhibits(response)
      this.isDestroying = true;
      setTimeout(() => {
        this.$refs.upload.removeFile(file)
      }, 1500)
    }
  }
};
</script>